import React, { useEffect, useState, useRef } from "react";
import "../../css_files/Customer/Customers.css";
import axiosInstance from "../../api";
import CustomerInfoPopup from "./CustomerInfoPopup";
import TicketInfo from "../Ticket/TicketInfo";
import EnquiryInfo from "../Enquiry/EnquiryInfo";
import QuotationInfo from "../Quotation/QuotationPopup";
import Pagination from "../Homepage/Pagination";
import { toast, ToastContainer } from "react-toastify";

function Customers({ setTicketId, setQuotationId, setEnquiryId }) {
  const [page, setpage] = useState(1);
  const [refresh, setrefresh] = useState(false);
  const [pagecount, setpagecount] = useState(0);
  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState(0);
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [showTicketInfo, setShowTicketInfo] = useState(false);
  const [showEnquiryInfo, setShowEnquiryInfo] = useState(false);
  const [ticketInfoData, setTicketInfoData] = useState();
  const [enquiryInfoData, setEnquiryInfoData] = useState();
  const [loading, setloading] = useState(false);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/api/v1/Customer/${page}`, {})
      .then((res) => {
        setCustomers(res.data.data);
        setpagecount(res.data.count);
        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
      });
  }, [page, refresh]);

  return (
    <section className="customers">
      <h1>Customers</h1>
      <input
        type="text"
        placeholder="Search Customer By Id or Name (Press Enter Key)"
        onInput={(e) => {
          if (e.target.value === "") setrefresh(!refresh);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/Customer/SearchCustomersByIdOrName?query=${e.target.value}`
              )
              .then((res) => {
                setCustomers(res.data);
                setpagecount(1);
              })
              .catch(console.log);
          }
        }}
      />
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
              <blockquote>
                <center>Id</center>
              </blockquote>
              <blockquote>
                <center>Customer/Company Name</center>
              </blockquote>
              <blockquote>
                <center>Code</center>
              </blockquote>
              <blockquote></blockquote>
            </aside>
          </div>
          <div>
            {loading ? (
              <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 4" }}>
                  <center>
                    <i
                      className="fa-solid fa-snowflake fa-spin"
                      style={{ fontSize: "2.5rem" }}
                    ></i>
                  </center>
                </blockquote>
              </aside>
            ) : customers.length > 0 ? (
              customers.map((customer) => (
                <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
                  <blockquote>
                    <center>{customer.id}</center>
                  </blockquote>
                  <blockquote>{customer.orgName}</blockquote>
                  <blockquote>
                    <center>{customer.pricing.code}</center>
                  </blockquote>
                  <blockquote
                    title="Click Here To See More Details"
                    onClick={() => {
                      setShowCustomerPopup(true);
                      setCustomerId(customer.id);
                    }}
                  >
                    <center>
                      <i className="fa-solid fa-info-circle"></i>
                    </center>
                  </blockquote>
                </aside>
              ))
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 4" }}>
                  <center>
                    <p>No Records Found</p>
                  </center>
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
      <Pagination count={pagecount} pagenumber={page} setpagenumber={setpage} />
      {showCustomerPopup && (
        <CustomerInfoPopup
          id={customerId}
          setShowCustomerPopup={setShowCustomerPopup}
          setShowTicketInfo={setShowTicketInfo}
          setTicketInfoData={setTicketInfoData}
          setshowenquiryInfo={setShowEnquiryInfo}
          setEnquiryInfoData={setEnquiryInfoData}
          setTicketId={setTicketId}
          setQuotationId={setQuotationId}
          setEnquiryId={setEnquiryId}
        />
      )}
      {showTicketInfo && (
        <TicketInfo
          setshowticketinfo={setShowTicketInfo}
          ticketinfodata={ticketInfoData}
        />
      )}
      {showEnquiryInfo && (
        <EnquiryInfo
          enquiryinfodata={enquiryInfoData}
          setshowenquiryInfo={setShowEnquiryInfo}
        />
      )}
    </section>
  );
}

export default Customers;
